import { LIEN_PRIORITIES_ACTION_TYPE } from '../actions';

const initialState = [];

const lienPrioritiesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LIEN_PRIORITIES_ACTION_TYPE.GET_USED_LIEN_PRIORITIES:
      return payload || initialState;

    default:
      return state;
  }
};

export default lienPrioritiesReducer;
